import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '../context';
import MainLoader from '../pages/MainLoader';
import { Navbar, Footer } from '../components';

const AppLayout = () => {
  const { token } = useAuthContext();
  const [loading, setLoading] = useState(true);
  const isFirstTokenChange = useRef(true);

  // 1) initial‐mount loader
  useEffect(() => {
    const t0 = setTimeout(() => setLoading(false), 3500);
    return () => clearTimeout(t0);
  }, []);

  // 2) token‐change loader (login / logout)
  useEffect(() => {
    if (isFirstTokenChange.current) {
      isFirstTokenChange.current = false;
      return;
    }
    setLoading(true);
    const t1 = setTimeout(() => setLoading(false), 3500);
    return () => clearTimeout(t1);
  }, [token]);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-white flex justify-center items-center z-50">
        <MainLoader />
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default AppLayout;
